<template>
    <div class="login-content">
        <div class="logoContainer">
            <div class="logo">
                <img src="../../static/logo1.png" alt="">
                <img style="width: 92px;height: auto;" src="../../static/logo-text.png" alt="">
            </div>

            <div class="leftContainer">
                <div class="title">
                    <h1>欢迎来到飞象宝</h1>
                    <div>
                        <span>使用账号密码登录</span>
                    </div>
                </div>
                <div class="login-form">
                    <a-form :form="form">
                        <a-input v-model="username" placeholder="请输入账号" v-decorator="['username', { rules: [{ required: true, message: '请输入账号' }] }]">
                            <a-icon slot="prefix" type="user" />
                        </a-input>
                        <a-input type="password" v-model="password" placeholder="请输入密码" v-decorator="['password', { rules: [{ required: true, message: '请输入密码' }] }]">
                            <a-icon slot="prefix" type="lock" />
                        </a-input>
                    </a-form>
                    

                    <div class="verifybox">
                        <!-- <a-input v-model="captcha" placeholder="请输入验证码"/> -->
                        <Verify @success="login()" :fontSize="fsize" :height="height" :width="width"  :figure="10" @error="login('验证码错误')"  :type="2"></Verify>
                    </div>
                   <!-- :showButton="false" -->
                    <!-- <a-row>
                        <a-col>
                            <a-checkbox  @change="onChange">同意《云销客用户协议》及《云销客隐私权政策》</a-checkbox>
                        </a-col>
                    </a-row> -->

                    <!-- <a-button @click="login" type="primary" style="width:100%">登录</a-button> -->

                    <!-- <a-divider>进入第三方</a-divider>
                    <a href="">
                        <img class="wx" src="../../static/wx.png" alt="">
                    </a> -->
        
                </div>
 
            </div>
        </div>
        
        <div class="rightContainer"></div>
    </div>
</template>

<script>
import Verify from 'vue2-verify'
export default {
    data(){
        return{
            form: this.$form.createForm(this, { name: 'coordinated' }),
            username:"",
            password:"",

            captcha:"",
            num:2,
            false:false,
            fsize:"20px",
            width:"161px",
            height:"50px",

        }
    },

    components: {
        Verify
    },

    methods:{
        login(text){
            console.log(text)
            if(text){
                this.$message.error(text);
            }else{
                this.$axios.post('/api/login/login',{
                    username:this.username,
                    password:this.password
                },{
                    headers: {
                        // "appid": this.appSet.appid,
                        // "appkey": this.appSet.appkey,
                        // "token":localStorage.getItem('token'),
                    }  
                }).then((res)=>{
                if(res.data.code==200){
                        this.$message.success('登录成功');
                        localStorage.setItem('token', res.data.data.token);
                        this.$router.push({ path:'/'  })
                    }else{
                        this.$message.error(res.data.msg);
                    }
                })
            }
            
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/login.vue